import qs from 'query-string';
import { deleteRequest, getRequest, patchRequest } from 'services/requests';

const services = {
    getAssignment: (id) => getRequest(`/assignments/${id}`),
    updateAssignment: (id, body) => patchRequest(`/assignments/${id}`, body),
    deleteAssignment: (id) => deleteRequest(`/assignments/${id}`),
    listAssignmentBatch: (id, filter, orderBy, skip, top, options = {}) => {
        const query = qs.stringify(
            { $filter: filter, $orderBy: orderBy, $skip: skip, $top: top },
            { skipNull: true, skipEmptyString: true }
        );
        return getRequest(`/assignments/${id}/batch${query && `?${query}`}`, options);
    },
    deleteAssignmentBatch: (id) => deleteRequest(`/assignments/${id}/batch`),
    listAssignmentFeedback: (id, filter, orderBy, skip, top, options = {}) => {
        const query = qs.stringify(
            { $filter: filter, $orderBy: orderBy, $skip: skip, $top: top },
            { skipNull: true, skipEmptyString: true }
        );
        return getRequest(`/assignments/${id}/feedback${query && `?${query}`}`, options);
    },
    deleteAssignmentFormatives: (id) => deleteRequest(`/assignments/${id}/formatives`),
    listAssignmentSubmissions: async (id, filter, orderBy, skip, top = 80, options = {}) => {
        let accumulatedResults = [];
        const query = qs.stringify(
            { $filter: filter, $orderBy: orderBy, $skip: skip, $top: top },
            { skipNull: true, skipEmptyString: true }
        );
        const { total, results } = await getRequest(`/assignments/${id}/submissions${query && `?${query}`}`, options);
        accumulatedResults = [...accumulatedResults, ...results];
        while (accumulatedResults.length < total) {
            const query = qs.stringify(
                { $filter: filter, $orderBy: orderBy, $skip: accumulatedResults.length, $top: top },
                { skipNull: true, skipEmptyString: true }
            );
            const { results } = await getRequest(`/assignments/${id}/submissions${query && `?${query}`}`, options);
            accumulatedResults = [...accumulatedResults, ...results];
        }
        return accumulatedResults;
    },
    deleteAssignmentSubmissions: (id, filter) => {
        const query = qs.stringify({ $filter: filter }, { skipNull: true, skipEmptyString: true });
        return deleteRequest(`/assignments/${id}/submissions${query && `?${query}`}`);
    },
};

export default services;
